export const SAVED_COLLECTIONS = '/collections'
export const SELECTION = '/summary/selection'
export const UPDATE_COLLECTION = '/collections/:collectionId'
export const DELETE_COLLECTION = '/collections/:collectionId'
